import { ChartType, Plugin } from "chart.js";

export function createHoverLinePlugin<T extends ChartType>({
  id = "hoverLine",
  color = "gray",
  lineWidth = 1,
  selectedLabelIndexRef,
  drawAfterDatasets = false,
}: {
  id?: string;
  color?: string;
  lineWidth?: number;
  selectedLabelIndexRef: React.MutableRefObject<number | null>;
  drawAfterDatasets?: boolean;
}): Plugin<T> {
  const drawLine = (chart: any) => {
    const { ctx, chartArea, scales } = chart;
    const xScale = scales.x;

    if (!chartArea || selectedLabelIndexRef.current === null) return;

    const fullIndex = selectedLabelIndexRef.current;
    const label = chart.data.labels?.[fullIndex];
    if (!label) return;

    // Find the tick index (among rendered ticks) that matches this label
    const renderedIndex = xScale.ticks.findIndex(
      (tick: any) => tick.label === label
    );

    if (renderedIndex === -1) return;

    const tickX = xScale.getPixelForTick(renderedIndex);

    const hasData = chart.data.datasets.some(
      (dataset: any) =>
        dataset.data[fullIndex] !== null &&
        dataset.data[fullIndex] !== undefined
    );
    if (!hasData) return;

    ctx.save();
    ctx.beginPath();
    ctx.setLineDash([]);
    ctx.moveTo(tickX, chartArea.top);
    ctx.lineTo(tickX, chartArea.bottom);
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.stroke();
    ctx.restore();
  };

  return {
    id,
    ...(drawAfterDatasets
      ? { afterDatasetsDraw: drawLine }
      : { beforeDatasetsDraw: drawLine }),
  };
}
